var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgClosedEye(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.08759 12.6895C3.26171 11.9067 2.61006 10.9586 2.17509 9.90703C2.10081 9.73405 2.0625 9.54777 2.0625 9.35953C2.0625 9.17128 2.10081 8.985 2.17509 8.81203C2.75274 7.40681 3.72095 6.19655 4.96509 5.32453C6.14597 4.49931 7.55989 4.07356 9.00009 4.10953C10.0363 4.08351 11.064 4.3019 12.0001 4.74703M13.9201 6.03703C14.7415 6.81915 15.3904 7.76437 15.8251 8.81203C15.8994 8.985 15.9377 9.17128 15.9377 9.35953C15.9377 9.54777 15.8994 9.73405 15.8251 9.90703C15.2474 11.3122 14.2792 12.5225 13.0351 13.3945C11.8542 14.2197 10.4403 14.6455 9.00009 14.6095C7.9639 14.6355 6.93616 14.4171 6.00009 13.972",
    stroke: "#878787",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6.5325 10.2375C6.42732 9.95694 6.37395 9.65962 6.375 9.36C6.375 8.66381 6.65156 7.99613 7.14384 7.50384C7.63613 7.01156 8.30381 6.735 9 6.735C9.3 6.7335 9.597 6.7875 9.8775 6.8925M11.4675 8.4825C11.5725 8.763 11.6265 9.06 11.625 9.36C11.625 10.0562 11.3484 10.7239 10.8562 11.2162C10.3639 11.7084 9.69619 11.985 9 11.985C8.70038 11.986 8.40306 11.9327 8.1225 11.8275M2.25 15L14.25 3",
    stroke: "#878787",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClosedEye);
export default __webpack_public_path__ + "static/media/closedEye.318ffd2a4ae635e173135ee1b0635dea.svg";
export { ForwardRef as ReactComponent };